import { render, staticRenderFns } from "./AppPictureInput.vue?vue&type=template&id=12872d0f&scoped=true&"
import script from "./AppPictureInput.vue?vue&type=script&lang=js&"
export * from "./AppPictureInput.vue?vue&type=script&lang=js&"
import style0 from "./AppPictureInput.vue?vue&type=style&index=0&id=12872d0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12872d0f",
  null
  
)

export default component.exports